import {TextBold16} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import {t} from "i18next";
import React, {memo} from "react";
import styles from "./styles.module.scss";

const ReadyToPlay = () => {
  return (
    <div className={styles.ready}>
      <TextBold16 text={t(s.readyToPlay)} className={styles.readyToPlay}/>
      <div className={styles.greenCircle}></div>
    </div>
  );
};

export default memo(ReadyToPlay);